import { fail, objectOf, requireRid, ridOf, textOf } from './wire'

/**
 * Конверт кассовых ручек C3a (договор C0): `{kind, resourceId, contractVersion,
 * schemaVersion, data}`. Версии и вид сверяются: ответ другой схемы — ошибка
 * на границе, а не тихая подстановка полей.
 */
export const AQSI_WIRE = {
  contractVersion: '1.0',
  schemaVersion: '1.0-draft.2',
} as const

/**
 * Декодер конверта для запроса ресурса `resourceId`. rid ответа сверяется с
 * запрошенным: два AQSI с одинаковыми кассами не смешиваются даже при ошибке маршрута.
 */
export function envelope<T>(
  kinds: string | readonly string[],
  resourceId: string,
  decodeData: (data: unknown) => T,
): (raw: unknown) => T {
  const allowed = typeof kinds === 'string' ? [kinds] : kinds
  return (raw) => {
    const body = objectOf(raw, 'ответ')
    const kind = textOf(body.kind, 'kind')
    if (!allowed.includes(kind)) fail(`kind ${kind}, ожидался ${allowed.join(' или ')}`)
    requireRid(ridOf(body.resourceId, 'resourceId'), resourceId, 'resourceId')
    if (body.contractVersion !== AQSI_WIRE.contractVersion || body.schemaVersion !== AQSI_WIRE.schemaVersion) {
      fail(`версия договора ${String(body.contractVersion)}/${String(body.schemaVersion)} не поддержана`)
    }
    return decodeData(body.data)
  }
}

/** Шапка каждой команды C3a: вид, rid, версии, наш UUID операции, ключ идемпотентности, ожидаемая версия. */
export interface CommandHeader {
  kind: string
  resourceId: string
  contractVersion: string
  schemaVersion: string
  operationId: string
  idempotencyKey: string
  expectedVersion: number
}

export function commandHeader(
  kind: string,
  resourceId: string,
  intent: { operationId: string; idempotencyKey: string },
  expectedVersion: number,
): CommandHeader {
  return {
    kind,
    resourceId,
    contractVersion: AQSI_WIRE.contractVersion,
    schemaVersion: AQSI_WIRE.schemaVersion,
    operationId: intent.operationId,
    idempotencyKey: intent.idempotencyKey,
    expectedVersion,
  }
}
